import { convertGroupsToItems } from '../../../utils/groupedListUtils';
import { PersonViewItem } from '../../PeoplePicker/PeoplePicker';
import { groupBy, map } from 'lodash-es';

export const groupAndFlatPeople = (people: ReadonlyArray<PersonViewItem>) => {
  const groupedPeople: ReadonlyArray<ReadonlyArray<PersonViewItem>> = map(groupBy(people, 'groupId'), group => group);
  return convertGroupsToItems(groupedPeople);
};
